module.exports = __webpack_public_path__ + "static/img/hud_right_top_corn_1.15cff2a2.png";